import request from "project-config/services/request/request";
import { IVerifyRechargeCodeParams } from "../types";

export const PictureTopUpAPI = Object.freeze({
  addMemberRecharge: (params: any) => {
    return request.post(
      "/api/rendering/pay/recharge/addMemberRecharge",
      params
    );
  },
  addPayRecord: (params: any) => {
    return request.post("/api/rendering/pay/recharge/addPayRecord", params);
  },
  verifyRechargeCode: (params: IVerifyRechargeCodeParams) => {
    return request.post(
      "/api/rendering/pay/recharge/verifyRechargeCode",
      params
    );
  },
});
